import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Editor } from "primereact/editor";

import classNames from "classnames";
import {
	Column,
	Toast,
	Button,
	Dialog,
	InputText,
	Dropdown,
	InputTextarea,
	TabView,
	TabPanel,
	tabHeaderIIespanol,
	tabHeaderIIingles,
} from "../../components/crud";
import { Conexion } from "../../service/Conexion";
import {
	TablaDatos,
	BarraSuperior,
	EliminarVentana,
	productDialogFooter,
} from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { setDataSet, setFormData } from "../../store/appSlice";
import { Cargando } from "../../components/crud/Cargando";
import { ImagenCampo } from "../../components/crud/ImagenCampo";

export const Faq = () => {
	const TABLA = "faq";
	let emptyFormData = {};
	const { dataSet, formData } = useSelector((state) => state.appsesion); //datos el storage redux
	const dispatch = useDispatch();
	const [productDialog, setProductDialog] = useState(false);
	const [deleteProductDialog, setDeleteProductDialog] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const toast = useRef(null);
	const [recargar, setrecargar] = useState(0);
	const [cargando, setCargando] = useState(false);
	const datatable = new Conexion();

	const [text1, setText1] = useState(
		"<div>Hello World!</div><div>PrimeReact <b>Editor</b> Rocks</div><div><br></div>"
	);

	useEffect(() => {
		//cargar la data total
		setCargando(true);
		dispatch(setFormData(emptyFormData));

		datatable.gettable(TABLA).then((data) => {
			dispatch(setDataSet(data));
			setCargando(false);
		});
	}, [recargar]);

	/*eventos*/
	const openNew = () => {
		dispatch(setFormData(emptyFormData));
		setSubmitted(false);
		setProductDialog(true);
	};
	const hideDialog = () => {
		setSubmitted(false);
		setProductDialog(false);
	};

	const hideDeleteProductDialog = () => {
		setDeleteProductDialog(false);
	};

	const editProduct = (id) => {
		setCargando(true);
		datatable
			.getItem(TABLA, id)
			.then((data) => dispatch(setFormData({ ...data.data })));
		setText1(formData.res_fac);

		setProductDialog(true);
		setCargando(false);
	};

	const confirmDeleteProduct = (fila) => {
		dispatch(setFormData(fila));
		setDeleteProductDialog(true);
	};
	const trasaccionExitosa = (tipo = "") => {
		setrecargar(recargar + 1);
		tipo === "borrar" ? setDeleteProductDialog(false) : hideDialog();
		dispatch(setFormData(emptyFormData));

		toast.current.show({
			severity: "success",
			summary: "Confirmacion",
			detail: "Transacción Exitosa",
			life: 4000,
		});
	};

	/*eventos*/

	/**operacion transacciones */
	const saveProduct = () => {
		valor();
		// return false;
		setSubmitted(true);
		if (formData.pre_fac?.trim()) {
			// console.log(formData);
			// debugger
			setCargando(true);
			if (formData.id == null) {
				//nuevo registro
				datatable
					.getCrearItem(TABLA, formData)
					.then((data) => trasaccionExitosa());
			} else {
				//editar registro
				datatable
					.getEditarItem(TABLA, formData, formData.id)
					.then((data) => trasaccionExitosa());
			}
		}
	};
	const deleteProduct = () =>
		datatable
			.getEliminarItem(TABLA, formData, formData.id)
			.then((data) => trasaccionExitosa("borrar"));
	/**operacion transacciones */

	/* validaciones de campos */
	const onInputChange = (e, name) => {
		// console.log(e.target, e.target?.value, name);
		// console.log(formData, "change");
		const val = (e.target && e.target.value) || "";
		let _product = { ...formData };
		_product[`${name}`] = val;
		// console.log(_product);
		dispatch(setFormData(_product));
	};

	const changeHtml = () => {
		console.log(text1, "htmlchange");
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<div
				className="actions"
				style={{
					display: "flex",
				}}
			>
				<Button
					icon="pi pi-pencil"
					className="p-button-rounded p-button-success mr-2"
					onClick={() => editProduct(rowData.id)}
				/>
				<Button
					icon="pi pi-trash"
					className="p-button-rounded p-button-warning mr-2"
					onClick={() => confirmDeleteProduct(rowData)}
				/>
			</div>
		);
	};

	const valor = () => {
		console.log("boton");
		let _product = { ...formData };
		_product[`res_fac`] = text1;
		setFormData(_product);
		// dispatch(setFormData(_product));
		// setFormData(...formData, ("res_fac": text1));
		// console.log(formData);
		// debugger;
	};

	return (
		<div className="grid">
			<div className="col-12">
				<div className="card">
					<Cargando cargando={cargando} />
					<Toast ref={toast} />
					<BarraSuperior openNew={openNew} />
					<TablaDatos datostabla={dataSet} titulo="FAQ">
						<Column
							field="pre_fac"
							header="Pregunta"
							sortable
							headerStyle={{ width: "60%", minWidth: "10rem" }}
						></Column>
						<Column
							field="ord_faq"
							header="Orden"
							sortable
							headerStyle={{ width: "30%", minWidth: "10rem" }}
						></Column>

						<Column header="Acciones" body={actionBodyTemplate}></Column>
					</TablaDatos>

					<Dialog
						visible={productDialog}
						style={{ width: "850px" }}
						header="Detalle FAQ"
						modal={true}
						className="p-fluid"
						footer={productDialogFooter(hideDialog, saveProduct)}
						onHide={hideDialog}
					>
						<TabView>
							<TabPanel
								className="justify-content: flex-end;"
								headerTemplate={tabHeaderIIespanol}
							>
								<div className="field ">
									{/* <pre>{JSON.stringify(formData,2)}</pre> */}
									<label htmlFor="pre_fac">Pregunta español:</label>
									<InputText
										id="pre_fac"
										value={formData.pre_fac}
										onChange={(e) => onInputChange(e, "pre_fac")}
										required
										autoFocus
										className={classNames({
											"p-invalid": submitted && !formData.pre_fac,
										})}
									/>
									{submitted && !formData.pre_fac && (
										<small className="p-invalid">Campo requerido.</small>
									)}
								</div>

								<div className="formgrid grid">
									<div className="field col">
										<label htmlFor="res_fac">Respuesta español:</label>
										<InputTextarea
											id="res_fac"
											value={formData.res_fac}
											onChange={(e) => onInputChange(e, "res_fac")}
											rows={6}
											cols={20}
										/>
									</div>
								</div>
								<div className="formgrid grid">
									<div className="field col-6">
										<label htmlFor="ord_faq">Orden:</label>
										<InputText
											id="ord_faq"
											value={formData.ord_faq}
											onChange={(e) => {
												onInputChange(e, "ord_faq");
												changeHtml("leo");
											}}
										/>
									</div>
								</div>
							</TabPanel>
							<TabPanel headerTemplate={tabHeaderIIingles}>
								<div className="field ">
									<label htmlFor="pre_fac_ing">Pregunta ingles:</label>

									<InputText
										id="pre_fac_ing"
										value={formData.pre_fac_ing}
										onChange={(e) => onInputChange(e, "pre_fac_ing")}
									/>
								</div>
								<div className="field col">
									<label htmlFor="res_fac_ing">Respuesta ingles:</label>
									<InputTextarea
										id="res_fac_ing"
										value={formData.res_fac_ing}
										onChange={(e) => onInputChange(e, "res_fac_ing")}
										required
										rows={6}
										cols={20}
									/>
								</div>
							</TabPanel>
						</TabView>
					</Dialog>
					<EliminarVentana
						deleteProductDialog={deleteProductDialog}
						product={formData.pre_fac}
						hideDeleteProductDialog={hideDeleteProductDialog}
						deleteProduct={deleteProduct}
					/>
				</div>
			</div>
		</div>
	);
};
